import { getSceneState } from "../../stores/sceneStore";
import { useSelectionStore } from "../../stores/selectionStore";
import type { Body, BodyUUID } from "../../types/scene";
import type { WorldBodyRef } from "./types";

export const findDeepestBody = (
  bodies: Record<BodyUUID, Body>,
  worldBodies: WorldBodyRef[]
): BodyUUID | null => {
  const roots = (worldBodies || [])
    .map((wb) => (typeof wb === "string" ? wb : wb?.uuid))
    .filter(Boolean) as BodyUUID[];
  let best: { depth: number; uuid: BodyUUID | null } = { depth: -1, uuid: null };
  const stack: Array<{ uuid: BodyUUID; depth: number }> = roots.map((uuid) => ({ uuid, depth: 0 }));
  while (stack.length) {
    const { uuid, depth } = stack.pop()!;
    if (depth > best.depth) best = { depth, uuid };
    const b = bodies?.[uuid];
    if (b && Array.isArray(b.children)) {
      b.children.forEach((child) => {
        if (typeof child === "string") stack.push({ uuid: child as BodyUUID, depth: depth + 1 });
      });
    }
  }
  return best.uuid;
};

export const getEndEffectorBody = (hint?: string | null) => {
  if (hint) return hint as BodyUUID;
  const selection = useSelectionStore.getState();
  if (selection?.selectedBody) return selection.selectedBody as BodyUUID;
  const scene = getSceneState();
  return findDeepestBody(scene.bodies || {}, scene.worldBodies || []) as BodyUUID | null;
};
